import CrudTable from '../../crud/CrudTable'
import {
    shareService as service,
    carService,
    usercompaniesService,
    billService,
} from '../../../services'

import FileDownloadIcon from '@mui/icons-material/PictureAsPdf'
import { Button } from '@mui/material'

const moment = require('moment')

const initFilter = {
    user: null,
    paymentState: null,
    from: null,
    to: null,
}

export default function Share() {
    const createEstructureFilter = [
        {
            type: 'autocomplete',
            name: 'user',
            service: usercompaniesService.combouser,
            col: 4,
        },
        {
            type: 'input',
            name: 'from',
            inputype: 'date',
            col: 4,
        },
        {
            type: 'input',
            name: 'from',
            inputype: 'to',
            col: 4,
        },
    ]

    const paintCell = {
        seguro: (value, object) => {
            return value ? (
                <>
                    <img src="/ic_secbig.png" style={{ width: '30px' }} />
                    <br />
                </>
            ) : (
                <></>
            )
        },
        km_real: (value, object) => {
            return <>{value ? value.toFixed(2) : 0} Km</>
        },
        paymentState: (value, object) => {
            if (value == 'NONE') {
                return <span style={{ color: 'black' }}>No realizado</span>
            } else if (value == 'PAYMENT') {
                return <span style={{ color: 'green' }}>Pagado</span>
            } else if (value == 'PARCIAL') {
                return <span style={{ color: 'orange' }}>Pago parcial</span>
            } else if (value == 'ERROR') {
                return <span style={{ color: 'red' }}>Error en el pago</span>
            } else {
                ;<></>
            }
        },
        start: (value, object) => {
            if (value) {
                return (
                    <>{moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')}</>
                )
            }
        },
        end: (value, object) => {
            if (value) {
                return (
                    <>{moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')}</>
                )
            }
        },
        rentalState: (value, object) => {
            if (value == 'RESERVED') {
                return <span style={{ color: 'black' }}>Reservado</span>
            } else if (value == 'CONFIRMRESERVED') {
                return (
                    <span style={{ color: 'black' }}>Reserva confirmada</span>
                )
            } else if (value == 'ASSIGNCAR') {
                return <span style={{ color: 'black' }}>Coche asignado</span>
            } else if (value == 'START') {
                return <span style={{ color: 'green' }}>Iniciado</span>
            } else if (value == 'END') {
                return <span style={{ color: 'green' }}>Finalizado</span>
            } else if (value == 'ISSUE') {
                return <span style={{ color: 'red' }}>Con incidencia</span>
            } else if (value == 'CANCEL') {
                return <span style={{ color: 'orange' }}>Cancelado</span>
            } else {
                ;<></>
            }
        },
        billed: (value, object) => {
            if (object['idBill']) {
                return (
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: '#83c63b',
                            color: 'white',
                        }}
                        onClick={() => {
                            billService.print(
                                object['idBill'],
                                'Factura-Share-' + object['id'] + '.pdf',
                                (data, error) => {}
                            )
                        }}
                    >
                        {' '}
                        <FileDownloadIcon />
                    </Button>
                )
            } else {
                return <></>
            }
        },
    }

    const conditionDelete = (share) => {
        var isGenerate =
            share &&
            share.id &&
            share.rentalState != '' &&
            share.rentalState == 'CANCEL'
        return isGenerate
    }

    return (
        <CrudTable
            service={service}
            urledit={'/share/edit/'}
            urlnew={'/share/new/'}
            filter={initFilter}
            hiddenButton={true}
            rowsPerPage={30}
            editable={false}
            paintCell={paintCell}
            deleteaction={false}
            notexport={true}
            conditionDelete={conditionDelete}
            i18n={'share'}
            exportfields={[
                'user.email',
                'user.name',
                'user.lastname',
                'user.nif',
                'car.number',
                'start',
                'end',
                'km_real',
                'min_standby',
                'paymentState',
                'total',
            ]}
            fieldstable={[
                'user.email|user.name|user.lastname',
                'car.brand|car.model|car.number',
                'seguro',
                'start',
                'end',
                'rentalState',
                'total',
                'km_real',
            ]}
            labels={{
                'user.email|user.name|user.lastname': 'Conductor',
                'car.brand|car.model|car.number': 'Vehículo',
                seguro: '',
            }}
            estructureForm={createEstructureFilter}
        />
    )
}
